/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { NavLink, useHistory } from "react-router-dom";
import "./sidedrawer.style.scss";
import CallationLogo from "../../assets/images/Callation-white-transparent.svg";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Navbar, Nav } from "react-bootstrap";
import { getRequest } from "../../utils/apiCallerUtil";
import {
  X,
  PeopleFill,
  LaptopFill,
  ChatLeftTextFill,
  Tools,
  QuestionCircleFill,
  DisplayFill,
  ShieldFillExclamation,
  CloudPlusFill,
  JournalBookmarkFill,
  BellFill
} from "react-bootstrap-icons";
import {
  selectSideNavToggle,
  selectUserMenu,
} from "../../redux/side-menu/side-menu.selector";
import { selectAuthenticationData } from "../../redux/user/user.selector";
import {
  toggleSideNav,
  setSideMenu,
} from "../../redux/side-menu/side-menu.actions";

const SideDrawer = ({
  userMenu,
  sideNavToggle,
  toggleSideNav,
  authData,
  setSideMenu,
}) => {
  const history = useHistory();

  useEffect(() => {
    if (authData && !userMenu) {
      getSideMenu();
    }
  }, [authData, userMenu]);

  const iconReference = {
    group: <PeopleFill />,
    computer: <LaptopFill />,
    card_membership: <DisplayFill />,
    vpn_lock: <ShieldFillExclamation />,
    handyman: <Tools />,
    library_books: <JournalBookmarkFill />,
    customer_add: <CloudPlusFill />,
    announcement: <ChatLeftTextFill />,
    help: <QuestionCircleFill />,
    alarm_icon: <BellFill />
  };

  const [triggerValueForDrawer, setTriggerValueForDrawer] = useState(false);

  const getSideMenu = async () => {
    let response = await getRequest("reseller-menu");
    if (response.status >= 200 && response.status < 300) {
      await setSideMenu(response.data.data);
    }
  };

  const checkLocationPath = (items) => {
    let value = false;
    items.forEach((element) => {
      if (history.location.pathname === element.link) {
        value = true;
      }
    });
    return value;
  };

  const onClickChange = () => {
    triggerValueForDrawer
      ? setTriggerValueForDrawer(false)
      : setTriggerValueForDrawer(true);
    if (parseInt(window.innerWidth) < 1100) {
      toggleSideNav();
    }
  };

  const renderMenuItems = () => {
    let menu = [];
    if (userMenu) {
      userMenu.forEach((item, id) => {
        if (item.external) {
          menu.push(
            <Nav.Item key={id}>
              <Nav.Link
                onClick={() => onClickChange()}
                id="side-drawer-navlink-deactive"
                href={item.link}
                target="blank"
              >
                {iconReference[item.icon]}
                <span className="side-drawer-item-title">{item.title}</span>
              </Nav.Link>
            </Nav.Item>
          );
        } else if (item.link) {
          menu.push(
            <Nav.Item key={id}>
              <Nav.Link
                onClick={() => onClickChange()}
                as={NavLink}
                id={
                  history.location.pathname === item.link
                    ? "side-drawer-navlink-active"
                    : "side-drawer-navlink-deactive"
                }
                to={item.link}
              >
                {iconReference[item.icon]}
                <span className="side-drawer-item-title">{item.title}</span>
              </Nav.Link>
            </Nav.Item>
          );
        } else {
          menu.push(
            <Nav.Item key={id}>
              <Nav.Link
                onClick={() => onClickChange()}
                as={NavLink}
                id={
                  checkLocationPath(item.children)
                    ? "side-drawer-navlink-active"
                    : "side-drawer-navlink-deactive"
                }
                to={item.children[0].link}
              >
                {iconReference[item.icon]}
                <span className="side-drawer-item-title">{item.title}</span>
              </Nav.Link>
            </Nav.Item>
          );
        }
      });
      menu.push(
        <Nav.Item key={userMenu.length + 2}>
          <Nav.Link
            onClick={() => onClickChange()}
            id="side-drawer-navlink-deactive"
            href="https://callation.freshdesk.com/support/home"
            target="blank"
          >
            {iconReference.help}
            <span className="side-drawer-item-title">Help/Support</span>
          </Nav.Link>
        </Nav.Item>
      );
    }
    return menu;
  };

  return (
    <div>
      <div
        className={
          "side-drawer-container " +
          (sideNavToggle ? "side-drawer-container-active" : "")
        }
        onClick={() => toggleSideNav()}
      ></div>
      <div
        className={
          "side-drawer-layout " + (sideNavToggle ? "" : "active-side-drawer")
        }
      >
        <div className="side-drawer-scroll">
          <div className="side-drawer-logo-header">
            <img className="image-size" src={CallationLogo} alt="" />
            <button onClick={toggleSideNav} className="side-drawer-back-cross">
              <X size={30} />
            </button>
          </div>
          <Navbar className="side-drawer-navbar">
            <Nav className="mr-auto side-drawer-nav-bar">
              {renderMenuItems()}
            </Nav>
          </Navbar>
        </div>
      </div>
    </div>
  );
};

// mapStateToProps provides us the required state stored in the redux store

const mapStateToProps = createStructuredSelector({
  userMenu: selectUserMenu,
  sideNavToggle: selectSideNavToggle,
  authData: selectAuthenticationData,
});

const mapDispatchToProps = (dispatch) => ({
  toggleSideNav: (status) => dispatch(toggleSideNav(status)),
  setSideMenu: (menu) => dispatch(setSideMenu(menu)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SideDrawer);
